import { SnackbarOrigin } from '@mui/material';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { uniqueId } from 'lodash';
import { VariantType } from 'notistack';
import { combineReducers } from 'redux';
import { AlertDialogModel, ConfirmDialogModel } from '../uiTypes';

const confirmDialogSlice = createSlice({
    name: 'confirmDialog',
    initialState: null as ConfirmDialogModel | null,
    reducers: {
        showConfirmDialog: (state, action: PayloadAction<ConfirmDialogModel>) => action.payload,
        hideConfirmDialog: () => null
    }
});
export const { showConfirmDialog, hideConfirmDialog } = confirmDialogSlice.actions;

const alertDialogSlice = createSlice({
    name: 'alertDialog',
    initialState: null as AlertDialogModel | null,
    reducers: {
        showAlertDialog: (state, action: PayloadAction<AlertDialogModel>) => action.payload,
        hideAlertDialog: () => null
    }
});
export const { showAlertDialog, hideAlertDialog } = alertDialogSlice.actions;

export type ShowSnackbarModel = {
    id?: string;
    message: string;
    autoHideDuration?: number;
    severity: VariantType;
    position?: SnackbarOrigin;
    persist?: boolean;
};
export type SnackbarModel = ShowSnackbarModel & {
    id: string;
    isOpen: boolean;
};

const snackbarsSlice = createSlice({
    name: 'snackbars',
    initialState: {} as { [id: string]: SnackbarModel },
    reducers: {
        enqueueSnackbar: (state, action: PayloadAction<ShowSnackbarModel>) => {
            const { payload } = action;

            const snackbar: SnackbarModel = {
                ...payload,
                isOpen: true,
                id: payload.id ?? uniqueId()
            };
            state[snackbar.id] = snackbar;
        },
        closeSnackbar: (state, action: PayloadAction<string>) => {
            state[action.payload].isOpen = false;
        },
        removeSnackbar: (state, action: PayloadAction<string>) => {
            delete state[action.payload];
        }
    }
});
export const { enqueueSnackbar, closeSnackbar, removeSnackbar } = snackbarsSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pricePrgError = createAction<any>('@ui/pricePrgError');
export const initialize = createAction('@ui/initialize');
export default combineReducers({
    confirmDialog: confirmDialogSlice.reducer,
    alertDialog: alertDialogSlice.reducer,
    snackbars: snackbarsSlice.reducer
});
